import { ColumnPoor } from "./ColumnPoor";
import { ZTableSettings } from "./TableStrategy";

type TableSettingsData = ZTableSettings["data"];

/**
 * Согласует сохранённые настройки с фактическим набором колонок.
 * Неизвестные ключи от удалённых атрибутов отбрасываются, новые колонки
 * добавляются в конец в порядке, в котором они пришли от таблицы.
 */
export const reconcileTableSettings = (
  settings: TableSettingsData,
  columns: ColumnPoor[],
): TableSettingsData => {
  const availableKeys = new Set(columns.map(({ key }) => key));
  const savedOrder = settings.columnOrder ?? [];
  const orderSet = new Set<string>();
  const columnOrder = savedOrder.filter((key) => {
    if (!availableKeys.has(key) || orderSet.has(key)) return false;
    orderSet.add(key);
    return true;
  });

  columns.forEach(({ key }) => {
    if (!orderSet.has(key)) {
      orderSet.add(key);
      columnOrder.push(key);
    }
  });

  const hiddenColumns = Array.from(
    new Set(settings.hiddenColumns.filter((key) => availableKeys.has(key))),
  );
  const columnWidths = Object.fromEntries(
    Object.entries(settings.columnWidths ?? {}).filter(([key]) =>
      availableKeys.has(key),
    ),
  );

  return {
    ...settings,
    hiddenColumns,
    columnWidths,
    columnOrder,
    fixedLeft:
      settings.fixedLeft === undefined
        ? undefined
        : Math.max(0, Math.min(settings.fixedLeft, columnOrder.length)),
  };
};
